import { PlatformLocation } from '@angular/common';
import { Component, Inject, Optional } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import { BaseComponent } from '../../../shared/base-components/base.component';
import { CustomerIndividualName } from '../../models/customer-individual-name.model';
import { CustomerIndividualNameSuffixType } from '../../models/enums/customer-individual-name-suffix-type.enum';

export class CustomerPhotoContext {
    constructor(public customerNumberId: number, public nameDetail: CustomerIndividualName = null) {
    }
}

@Component({
    selector: 'customer-photo-modal',
    templateUrl: './individual-customer-photo-modal.html'
})
export class CustomerPhotoModalComponent extends BaseComponent {
    public customerNumberId: number;
    public nameSuffixTypes: CustomerIndividualNameSuffixType = new CustomerIndividualNameSuffixType();

    constructor(
        public location: PlatformLocation,
        public dialogRef: MatDialogRef<CustomerPhotoModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: CustomerPhotoContext
    ) {
        super();
        this.customerNumberId = this.data.customerNumberId;
        location.onPopState(() => {
            this.dialogRef.close();
        });
    }

    public ngOnInit() {
    }

    public cancel() {
        this.dialogRef.close();
    }

    public getValues(id: number, types: any): string {
        if (id !== undefined && id !== null) {
            return types.FromId(id).displayValue;
        } else {
            return '';
        }
    }
}
